<p-card styleClass="card-container" header="Site Data Summary">
  This is a <b>IOT application</b> which gathers and stores sensor data using
  MQTT and MongoDB, apply business rules, expose data using rest api services
  for front end to consume. My role is <b>IOT developer</b> and my
  responsibility is to develop process flow using Node-Red to store and expose
  data using MQTT/MongoDB and to develop functions to apply business rules.This
  POC is developed using <b>Javascript , Node , Raspberry PI 3 ,Node-Red</b>
  <b>Raspberry-pi </b> device is used for processing.
</p-card>
